import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import { cryptoApi } from '@/services/api';

export const makeStore = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return configureStore({
    reducer: {
      [cryptoApi.reducerPath]: cryptoApi.reducer
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: !isDevelopment,
        immutableCheck: !isDevelopment
      }).concat(cryptoApi.middleware),
    devTools: isDevelopment
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const wrapper = createWrapper<AppStore>(makeStore, { debug: false });
